import { useEffect, useState } from 'react';
import { fetch } from '../../utils/api-wrapper';

/** Preview only: edits stay local, and replies for older coding cannot enable Save. */
export default function useCardFacilityPreview({ enabled, statementId, checksum, draft }) {
  const signature = JSON.stringify(draft || null);
  const key = `${statementId}/${checksum}/${signature}`;
  const [result, setResult] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!enabled || !draft) return undefined;
    let cancelled = false;
    const timer = setTimeout(() => {
      fetch(`/c_card/expenses/${encodeURIComponent(statementId)}/${encodeURIComponent(checksum)}/facility-preview`,
        'POST', { json: JSON.parse(signature) }, response => {
          if (cancelled) return;
          const preview = response?.data;
          const valid = Array.isArray(preview?.lines) && preview.lines.length > 0 && Array.isArray(preview?.issues);
          setResult({ key, attempt, preview: valid ? preview : null, error: !valid });
        }, () => { if (!cancelled) setResult({ key, attempt, error: true }); });
    }, 250);
    return () => { cancelled = true; clearTimeout(timer); };
    // The signature represents the draft; object identity changes are irrelevant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled, statementId, checksum, signature, attempt]);
  const current = result?.key === key && result?.attempt === attempt ? result : null;
  const pending = enabled && !current;
  const error = enabled && Boolean(current?.error);
  const issues = current?.preview?.issues || [];
  return {
    line: current?.preview?.lines?.[0], options: current?.preview?.options, pending, error, issues,
    blocked: Boolean(enabled && (pending || error || issues.length)),
    retry: () => setAttempt(value => value + 1),
  };
}
